module.exports = __webpack_public_path__ + "static/img/ContacCode1.2bde625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/ContacCode1.jpg
// module id = YzWa
// module chunks = 1